/* eslint-disable @typescript-eslint/no-explicit-any */
import { useDispatch } from "react-redux";
import { resetFilters, setFilter, setPagination, setSort } from "..";
import { SortField, SortOrder } from "../type";

type FilterKeys =
  | "storeIds"
  | "dateFrom"
  | "dateTo"
  | "status"
  | "meta";

export const useCavOfflineSyncFilterActions = () => {
  const dispatch = useDispatch();

  const updateFilter = (key: FilterKeys, value: any) => {
    dispatch(setFilter({ key, value }));
  };

  const clearFilters = () => {
    dispatch(resetFilters());
  };

  const updatePagination = (currentPage: number, perPage: number) => {
    dispatch(setPagination({ currentPage, perPage }));
  };

  const updateSort = (sortBy: SortField | undefined, sortOrder: SortOrder | undefined) => {
    dispatch(setSort({ sortBy, sortOrder }));
  };

  return { updateFilter, clearFilters, updatePagination, updateSort };
};
